import React from 'react';
import {
  XYPlot,
  makeWidthFlexible,
  LabelSeries,
  HorizontalBarSeries,
  YAxis,
} from 'react-vis';

const FlexibleXYPlots = makeWidthFlexible(XYPlot);

export default function({ data, colorRange, className }) {
  const maxYDomain = data.length
    ? Math.max(...data.map(({ valid_votes_pct }) => valid_votes_pct)) + 7
    : 30;

  const processedForHorizontal = data
    .filter(({ valid_votes_pct }) => valid_votes_pct >= 3)
    .map(({ custom_abbreviation, valid_votes_pct, id }) => {
      return {
        color: valid_votes_pct >= 5 ? id - 1 : colorRange.length - 1,
        y: custom_abbreviation,
        x: valid_votes_pct,
        label: `${valid_votes_pct}%`,
        xOffset: 20,
        style: {
          fontSize: 10,
          fontWeight: '600',
          transform: 'translate(100px, 10px)'
        },
      };
    })
    .reverse();
  return (
    <FlexibleXYPlots
      colorRange={colorRange}
      colorDomain={colorRange.map((d, i) => i)}
      height="300"
      colorScale="category"
      yType="ordinal"
      xDomain={[0, maxYDomain]}
      margin={{left: 40, right: 10, top: 10, bottom: 40}}
      className={className}
    >
      <YAxis     
        tickSizeOuter={-35}
        style={{ fontSize: '10px', marginLeft: '20px',text: {stroke: 'none', fill: '#6b6b76', fontWeight: 600} }} 
      />
      <HorizontalBarSeries
        className=""
        data={processedForHorizontal}
        stack={false}        
      />
      <LabelSeries
        data={processedForHorizontal}
        animation
        labelAnchorX="middle"
        labelAnchorY="middle"
      />
    </FlexibleXYPlots>
  );
}



// WEBPACK FOOTER //
// ./src/ui/src/component/electionWidget/horizontalBarChart.js